import { create } from 'zustand';
import { devtools } from "zustand/middleware";
import type { ITestLiveStore } from '../types/zustand/test-live-mode';
import { LOCAL_STORAGE_KEYS } from '../constants/local-storage-keys';
import { COOKIES_KEYS } from '../constants/cookies-keys';
import { deleteFromLocalStorage, getFromLocalStorage } from '../utils/manageLocalStorage';
import { getCookie, setCrossSubdomainsCookie } from '../utils/manageCookies';

const COOKIE_EXP_IN_DAYS = 400;

const hostname = window.location.hostname;
const domain = hostname === 'localhost' ?
  'localhost'
  :
  '.paymob.com';

const getIsLive = () => {
  let isLive = false;

  const modeFromStorage = getFromLocalStorage(LOCAL_STORAGE_KEYS.IS_LIVE);
  const modeFromCookies: boolean | null = JSON.parse(getCookie(COOKIES_KEYS.IS_LIVE_MODE) || 'null');

  if (typeof modeFromStorage === 'boolean') {
    isLive = modeFromStorage;
    
    setCrossSubdomainsCookie({
      name: COOKIES_KEYS.IS_LIVE_MODE,
      value: modeFromStorage,
      domain: domain,
      expInDays: COOKIE_EXP_IN_DAYS
    });
    
    deleteFromLocalStorage(LOCAL_STORAGE_KEYS.IS_LIVE);
  } else {
    isLive = modeFromCookies || false;
  }

  return isLive;
};

const setIsLiveMode = (isLive: boolean) => {

  setCrossSubdomainsCookie({
    name: COOKIES_KEYS.IS_LIVE_MODE,
    value: isLive,
    domain: domain,
    expInDays: COOKIE_EXP_IN_DAYS
  });

  return (
    { isLive }
  )
};

export const useTestLiveModeStore = create<ITestLiveStore>()(
  devtools(
    (set) => ({
      isLive: getIsLive(),
      setIsLive: (isLive) => set(
        setIsLiveMode(isLive),
        undefined,
        'TestLiveModeStore/setIsLive'
      ),
    } as ITestLiveStore),
    { name: 'TestLiveModeStore' }
  )
);
